import { BuildingDTO } from "./building";
import { ResourceType } from "./resource";

export enum AcquisitionSource {
  IMMO_WEBSITE = 'Immo website',
  NETWORK = 'Netwerk',
  PUBLIC_SALE = 'Openbare verkoop',
  YALLY_WEBSITE = 'Yally website',
}

export enum AcquisitionProLabels {
  Ligging = 'Ligging',
  PrijsPerM2 = 'Prijs/m2',
  DeelsGerenoveerd = 'Deels gerenoveerd',
  HistorischeHuurprijzen = 'Historische huurprijzen',
  AlleenInOnderhandeling = 'Alleen in onderhandeling',
  EPCBelowC = 'EPC < C',
  Doorzonappartementen = 'Doorzonappartementen',
  Ontwikkelingsmogelijkheden = 'Ontwikkelingsmogelijkheden',
  Volume = 'Volume',
  VolledigGerenoveerd = 'Volledig gerenoveerd',
  Vergund = 'Vergund',
  BeslissingssnelheidEigenaars = 'Beslissingssnelheid eigenaars',
  MoetVerkochtWorden = 'Moet verkocht worden',
  Rendement = 'Rendement',
  Verhuurd = 'Verhuurd',
  Zicht = 'Zicht',
  VerminderdeRegistratierechten = 'Verminderde registratierechten',
  EsthetischTop = 'Esthetisch top',
  HuurgarantieBespreekbaar = 'Huurgarantie bespreekbaar',
  MeerwaardeBijVerkoop = 'Meerwaarde bij verkoop',
  Residentieel = '100% residentieel',
  RenovatieBeperkt = 'Renovatie beperkt',
  ExtraBouwlagenUnitsTeCreeren = 'Extra bouwlagen/units te creëren',
  StevigeStructuur = 'Stevige structuur',
}

export enum AcquisitionConLabels {
  Prijs = 'Prijs',
  LiggingCon = 'Ligging',
  RenovatieTeGroot = 'Renovatie (te) groot',
  TeKleinVolume = 'Te klein volume',
  MoeilijkeOnderhandeling = 'Moeilijke onderhandeling',
  Biedprocedure = 'Biedprocedure',
  TechnischeIssues = 'Technische issues',
  HogeOV = 'Hoge OV',
  RetailKantorenTeGroot = 'Retail, kantoren te groot',
  GeenPotentieel = 'Geen potentieel',
  GeenYallyzone = 'Geen Yallyzone',
  GeenPrio = 'Geen prio',
  GeenBuitenruimte = 'Geen buitenruimte',
  Bouwovertredingen = 'Bouwovertredingen',
  BeslissingssnelheidEigenaarsCon = 'Beslissingssnelheid eigenaars',
  HuurprijzenHoog = 'Huurprijzen hoog',
  RendementCon = 'Rendement',
  VerkopersWillenEnkelDePrijsChecken = 'Verkopers willen enkel de prijs checken',
  GeenFietsenstalling = 'Geen fietsenstalling',
  GeenParkings = 'Geen parkings',
  ZichtCon = 'Zicht',
  OnveiligeBuurt = 'Onveilige buurt',
  RuimtesTeKlein = 'Ruimtes te klein',
  VolledigRecenteNieuwbouw = 'Volledig recente nieuwbouw',
  SinguliereUnitMedeEigendom = 'Singuliere Unit / Mede-Eigendom',
  PlafondhoogteBelow25m = 'Plafondhoogte < 2,5 m',
  OnvergundeUnits = 'Onvergunde units',
  Ontwikkelingstijd = 'Ontwikkelingstijd',
  MargeNaRenovatieLaag = 'Marge na renovatie laag',
  SlechtGerenoveerd = 'Slecht gerenoveerd',
  GeenKwalitatieveHuurders = 'Geen kwalitatieve huurders',
  NietEnergiezuinig = 'Niet energiezuinig',
  GeenHuurincasso = 'Geen huurincasso',
  StructuurNietStevig = 'Structuur niet stevig',
}

export enum AcquisitionPhase {
  INBOX = 'Inbox',
  ADD_DATA = "Opgepikt",
  ACQUISITION_MEETING_AGENDA = "Agenda ACQ meeting",
  RVB_AGENDA = "Agenda RVB",
  DEAL = "Deal!",
  REJECTED = "Afgewezen",
}


export enum DealType {
  ASSET_DEAL = "Asset deal",
  SHARE_DEAL = "Share deal",
  UNKNOWN = "Onbekend"
}

export enum ApprovalStatus {
  APPROVED = "Goedgekeurd",
  REJECTED = "Afgewezen",
  UNKNOWN = "Onbekend"
}

export enum CompleteStatus {
  COMPLETE = "Volledig",
  INCOMPLETE = "Onvolledig",
  UNKNOWN = "Onbekend"
}

export type Acquisition = {
  id?: number;
  name: string;
  buildings: BuildingDTO[]
  isEmailImport: boolean;
  emailFrom: string | null;
  emailReceivedAt: string | null;
  grossAskingPrice: number;
  emailSubject?: string;
  emailBody?: string;
  netAskingPrice?: number;
  avgPriceResidentialUnit?: number;
  estimatedYieldOfficeStorageNet?: number;
  estimatedYieldRetailNet?: number;
  priceParkingPlacesCoveredNet?: number;
  priceParkingPlacesNotCoveredNet?: number;
  priceStorageNet?: number;
  totalBid?: number;
  fiscalDiscountRealEstate?: string;
  fiscalDiscountCompanyShares?: string;
  priceBicycleStorageNet?: number;
  transactionCostsGross?: string;
  transactionCostsNet?: string,
  brokerCostsGross?: string,
  brokerCostsNet?: string,
  bidPriceActualNetYield?: string,
  bidPriceWorstCaseNetYield?: string
  bidPriceBestCaseNetYield?: string,
  transactionCostsNetYield?: string,
  renovationBudgetNetYield?: string,
  totalCashOutNetYield?: string,
  bidPriceActualPerSqm?: string,
  bidPriceWorstCasePerSqm?: string,
  bidPriceBestCasePerSqm?: string,
  renovationBudgetPerSqm?: string,
  rentActualPerSqm?: string,
  rentWorstCasePerSqm?: string,
  rentBestCasePerSqm?: string,
  grossActualRent: number;
  description: string;
  dealType: DealType;
  acquisitionSource: AcquisitionSource | null;
  acquisitionSourceUrl: string;
  yallyResponsibleUserId?: string;
  lastUpdatedExcel?: string;
  yallyResponsibleUser: any;
  /** Clerk user id of the person who originally brought in the dossier (sourcing). */
  aangebrachtDoor?: string;
  approvedAcq?: ApprovalStatus;
  approvedRvb?: ApprovalStatus;
  infoComplete?: CompleteStatus; // if information is complete to present to RVB
  acquisitionProReasons: AcquisitionProLabels[];
  acquisitionConReasons: AcquisitionConLabels[];
  saleReason: string;
  intermediaryResourceId?: string;
  ownerResourceId?: string;
  acquisitionPhase?: AcquisitionPhase;
  acquisitionDealAppreciation: string;
  owner?: {
    id: number,
    resourceId: number,
    type: ResourceType,
    name: string,
    sharePointFolderId: string,
    sharePointPicturesFolderId: string,
  } | null;
  intermediary?: {
    id: number,
    resourceId: number,
    type: ResourceType,
    name: string,
    sharePointFolderId: string,
    sharePointPicturesFolderId: string,
  } | null;
  sharePointFolderId?: string;
  sharePointFolderUrl?: string;
  sharePointSpreadsheetId?: string;
  sharePointSpreadsheetUrl?: string;
  createdAt?: Date;

  totalResidentialUnits?: string;
  totalNonResidentialUnits?: string;
  totalParkingsWithCover?: string;
  totalParkingsNoCover?: string;
  totalStorages?: string;
  bicycleStorages?: string;
  surfaceNonResidential?: string;
  surfaceResidential?: string;
  valueParkings?: string;
  valueStorages?: string;
  valueBicycleStorages?: string;
  valueNonResidential?: string;
  valueResidential?: string;
  askingPriceSqmResidential?: string;
  bidPriceSqmResidential?: string;
  bidPriceActual?: string;
  bidPriceWorstCase?: string;
  bidPriceBestCase?: string;
  transactionCosts?: string;
  renovationBudget?: string;
  totalCashOut?: string;
  potentialGrossIncomeActual?: string;
  netOperatingIncomeActual?: string;
  potentialGrossIncomeWorstCase?: string;
  netOperatingIncomeWorstCase?: string;
  potentialGrossIncomeBestCase?: string;
  netOperatingIncomeBestCase?: string;
  estimatedYieldOfficeStorage?: string;
  estimatedYieldRetail?: string;
  priceParkingPlacesCovered?: string;
  priceParkingPlacesNotCovered?: string;
  priceStorage?: string;
  priceBicycleStorage?: string;

  // ... Add other fields as per your requirements

  // @OneToMany() for buildings, images, etc. if they are separate entities
}
